import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const TX = {
  es: {
    titulo: 'EduNova Juegos', subtitulo: 'Aprende español jugando. Cada juego refuerza tu vocabulario y cultura.',
    dif_Facil: 'Facil', dif_Medio: 'Medio', dif_Dificil: 'Dificil', jugar: 'Jugar →', proximamente: 'Proximamente',
    verTrad: 'Ver traduccion', ocultarTrad: 'Ocultar traduccion', volver: '← Volver', volverSolo: 'Volver', jugarOtra: 'Jugar de nuevo',
    siguiente: 'Siguiente →', verResultado: 'Ver resultado', correctoPunto: 'Correcto! +1 punto', incorrecto: 'Incorrecto',
    tiempoAgotado: 'Tiempo agotado', puntaje: 'Puntaje:', xpGanados: 'XP ganados!', correcto: 'Correcto!',
    hTitulo: 'Ahorcado', pista: 'Pista:', errores: 'Errores:', excelente: 'Excelente! ', palabraEra: 'La palabra era: ', nuevaPalabra: 'Nueva palabra',
    triviaFin: 'Trivia completada', triviaTitulo: 'Trivia Colombiana',
    memoriaTitulo: 'Memoria de Palabras', intentos: 'Intentos:', completadoEn: 'Completado en', intentosPl: 'intentos!',
    juegoFin: 'Juego completado', ordenarTitulo: 'Ordena la Frase', traduccionLbl: 'Traduccion:', ordenaPalabras: 'Ordena las palabras:',
    tocaPalabras: 'Toca las palabras para agregarlas...', fraseCorrecta: 'Incorrecto. La frase correcta es:', comprobar: 'Comprobar',
    vofFin: 'Verdadero o Falso completado', vofTitulo: 'Verdadero o Falso', verdadero: 'Verdadero', falso: 'Falso',
    verbosFin: 'Conjugacion Rapida completada', verbosTitulo: 'Conjugacion Rapida', conjuga: 'Conjuga', para: 'para'
  },
  en: {
    titulo: 'EduNova Games', subtitulo: 'Learn Spanish by playing. Every game strengthens your vocabulary and culture knowledge.',
    dif_Facil: 'Easy', dif_Medio: 'Medium', dif_Dificil: 'Hard', jugar: 'Play →', proximamente: 'Coming soon',
    verTrad: 'Show translation', ocultarTrad: 'Hide translation', volver: '← Back', volverSolo: 'Back', jugarOtra: 'Play again',
    siguiente: 'Next →', verResultado: 'See result', correctoPunto: 'Correct! +1 point', incorrecto: 'Incorrect',
    tiempoAgotado: "Time's up", puntaje: 'Score:', xpGanados: 'XP earned!', correcto: 'Correct!',
    hTitulo: 'Hangman', pista: 'Hint:', errores: 'Mistakes:', excelente: 'Excellent! ', palabraEra: 'The word was: ', nuevaPalabra: 'New word',
    triviaFin: 'Trivia completed', triviaTitulo: 'Colombian Trivia',
    memoriaTitulo: 'Word Memory', intentos: 'Attempts:', completadoEn: 'Completed in', intentosPl: 'attempts!',
    juegoFin: 'Game completed', ordenarTitulo: 'Sentence Builder', traduccionLbl: 'Translation:', ordenaPalabras: 'Put the words in order:',
    tocaPalabras: 'Tap the words to add them...', fraseCorrecta: 'Incorrect. The correct sentence is:', comprobar: 'Check',
    vofFin: 'True or False completed', vofTitulo: 'True or False', verdadero: 'True', falso: 'False',
    verbosFin: 'Quick Conjugation completed', verbosTitulo: 'Quick Conjugation', conjuga: 'Conjugate', para: 'for'
  }
}

export default function EduNovaJuegos({ usuario, onXpGanado, idioma = 'es' }) {
  const [juegoActivo, setJuegoActivo] = useState(null)
  const t = TX[idioma] || TX.es

  const juegos = [
    { id:'ahorcado', ic:'🎯', nombre:'Ahorcado',            desc:'Adivina la palabra en español antes de que sea tarde.',       color:'#7C3AED', dificultad:'Facil',   en:{ nombre:'Hangman',             desc:'Guess the Spanish word before time runs out.' } },
    { id:'trivia',   ic:'🇨🇴', nombre:'Trivia Colombiana',   desc:'Pon a prueba tu conocimiento sobre Colombia y su cultura.',   color:'#F59E0B', dificultad:'Medio',   en:{ nombre:'Colombian Trivia',    desc:'Test your knowledge about Colombia and its culture.' } },
    { id:'memoria',  ic:'🧠', nombre:'Memoria de Palabras',  desc:'Encuentra los pares de palabras en español e inglés.',       color:'#059669', dificultad:'Medio',   en:{ nombre:'Word Memory',         desc:'Find the matching pairs of Spanish and English words.' } },
    { id:'ordenar',  ic:'📝', nombre:'Ordena la Frase',      desc:'Organiza las palabras para formar una frase correcta.',      color:'#F07C1E', dificultad:'Medio',   en:{ nombre:'Sentence Builder',    desc:'Put the words in order to make a correct sentence.' } },
    { id:'vof',      ic:'⚖️', nombre:'Verdadero o Falso',    desc:'Responde rapido: es cierto o falso sobre Colombia?',         color:'#3B82F6', dificultad:'Facil',   en:{ nombre:'True or False',       desc:'Answer fast: true or false about Colombia?' } },
    { id:'verbos',   ic:'⚡', nombre:'Conjugacion Rapida',   desc:'Conjuga verbos en español contra el reloj.',                 color:'#EF4444', dificultad:'Dificil', en:{ nombre:'Quick Conjugation',   desc:'Conjugate Spanish verbs against the clock.' } },
  ]

  const jugables = ['ahorcado','trivia','memoria','ordenar','vof','verbos']

  if (juegoActivo === 'ahorcado') return <JuegoAhorcado onVolver={() => setJuegoActivo(null)} idioma={idioma} />
  if (juegoActivo === 'trivia')   return <JuegoTrivia          onVolver={() => setJuegoActivo(null)} usuario={usuario} onXpGanado={onXpGanado} idioma={idioma} />
  if (juegoActivo === 'memoria')  return <JuegoMemoria  onVolver={() => setJuegoActivo(null)} idioma={idioma} />
  if (juegoActivo === 'ordenar')  return <JuegoOrdenar  onVolver={() => setJuegoActivo(null)} idioma={idioma} />
  if (juegoActivo === 'vof')      return <JuegoVerdaderoFalso  onVolver={() => setJuegoActivo(null)} usuario={usuario} onXpGanado={onXpGanado} idioma={idioma} />
  if (juegoActivo === 'verbos')   return <JuegoVerbos          onVolver={() => setJuegoActivo(null)} usuario={usuario} onXpGanado={onXpGanado} idioma={idioma} />

  return (
    <div style={{ maxWidth:900, margin:'0 auto' }}>
      <div style={{ background:'linear-gradient(135deg,#065F46,#059669)', borderRadius:16, padding:24, marginBottom:28, color:'#fff' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:36 }}>🎮</span>
          <div>
            <h1 style={{ fontSize:22, fontWeight:800, marginBottom:2 }}>{t.titulo}</h1>
            <p style={{ fontSize:13, opacity:.8 }}>{t.subtitulo}</p>
          </div>
        </div>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16 }}>
        {juegos.map(j => (
          <div key={j.id}
            onClick={() => jugables.includes(j.id) ? setJuegoActivo(j.id) : null}
            style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:14, padding:20,
              cursor: jugables.includes(j.id) ? 'pointer' : 'default',
              transition:'all .18s ease', position:'relative', overflow:'hidden' }}
            onMouseOver={e => { if(jugables.includes(j.id)) { e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.1)' }}}
            onMouseOut={e => { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='none' }}>
            <div style={{ position:'absolute', top:0, left:0, right:0, height:4, background:j.color }} />
            <div style={{ fontSize:36, marginBottom:12, marginTop:8 }}>{j.ic}</div>
            <div style={{ fontSize:15, fontWeight:700, color:'#1A1A2E', marginBottom:6 }}>{idioma === 'en' ? j.en.nombre : j.nombre}</div>
            <div style={{ fontSize:12, color:'#6B7280', marginBottom:12, lineHeight:1.5 }}>{idioma === 'en' ? j.en.desc : j.desc}</div>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <span style={{ fontSize:11, padding:'2px 8px', borderRadius:999, fontWeight:600,
                background: j.dificultad==='Facil' ? '#F0FDF4' : j.dificultad==='Medio' ? '#FEF9C3' : '#FEF2F2',
                color: j.dificultad==='Facil' ? '#166534' : j.dificultad==='Medio' ? '#854D0E' : '#991B1B' }}>
                {t['dif_' + j.dificultad]}
              </span>
              {jugables.includes(j.id)
                ? <span style={{ fontSize:12, color:j.color, fontWeight:700 }}>{t.jugar}</span>
                : <span style={{ fontSize:11, color:'#9CA3AF' }}>{t.proximamente}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

/* Boton reutilizable de traduccion opcional */
function BotonTraduccion({ activo, onClick, color = '#374151', t }) {
  return (
    <button onClick={onClick}
      style={{ display:'flex', alignItems:'center', gap:6, background: activo ? color : '#fff', color: activo ? '#fff' : color,
        border:'1.5px solid ' + color, borderRadius:999, padding:'5px 12px', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>
      🌐 {activo ? t.ocultarTrad : t.verTrad}
    </button>
  )
}

function JuegoAhorcado({ onVolver, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const palabras = [
    { palabra:'parce',   pista:'Amigo cercano en bogotano', pistaEn:'Close friend, Bogota slang' },
    { palabra:'bacano',  pista:'Algo muy bueno o chevere', pistaEn:'Something very good or cool' },
    { palabra:'quiubo',  pista:'Saludo informal bogotano', pistaEn:'Informal Bogota greeting' },
    { palabra:'chevere', pista:'Algo genial o agradable', pistaEn:'Something great or pleasant' },
    { palabra:'tinto',   pista:'Cafe negro colombiano', pistaEn:'Colombian black coffee' },
    { palabra:'ajiaco',  pista:'Sopa tipica bogotana', pistaEn:'Typical Bogota soup' },
    { palabra:'cachaco', pista:'Persona de Bogota', pistaEn:'A person from Bogota' },
  ]
  const [idx, setIdx] = useState(() => Math.floor(Math.random() * palabras.length))
  const [letrasUsadas, setLetrasUsadas] = useState([])
  const [errores, setErrores] = useState(0)
  const [ganado, setGanado] = useState(false)
  const [perdido, setPerdido] = useState(false)
  const MAX = 6
  const palabraActual = palabras[idx].palabra.toLowerCase()

  function intentarLetra(letra) {
    if (letrasUsadas.includes(letra) || ganado || perdido) return
    const nuevas = [...letrasUsadas, letra]
    setLetrasUsadas(nuevas)
    if (!palabraActual.includes(letra)) {
      const e = errores + 1
      setErrores(e)
      if (e >= MAX) setPerdido(true)
    } else {
      if (palabraActual.split('').every(l => nuevas.includes(l))) setGanado(true)
    }
  }

  function reiniciar() {
    setIdx(Math.floor(Math.random() * palabras.length))
    setLetrasUsadas([]); setErrores(0); setGanado(false); setPerdido(false)
  }

  const figura = ['😊','😐','😟','😨','😰','😱','💀'][errores]
  const teclado = 'abcdefghijklmnopqrstuvwxyz'.split('')

  return (
    <div style={{ maxWidth:600, margin:'0 auto' }}>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
        <button onClick={onVolver} style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit' }}>{t.volver}</button>
        <h2 style={{ fontSize:20, fontWeight:800 }}>🎯 {t.hTitulo}</h2>
      </div>
      <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:14, padding:32, textAlign:'center' }}>
        <div style={{ fontSize:64, marginBottom:8 }}>{figura}</div>
        <div style={{ fontSize:13, color:'#6B7280', marginBottom:4 }}>{t.pista} {idioma === 'en' ? palabras[idx].pistaEn : palabras[idx].pista}</div>
        <div style={{ fontSize:13, color:'#EF4444', marginBottom:20 }}>{t.errores} {errores}/{MAX}</div>
        <div style={{ display:'flex', justifyContent:'center', gap:8, marginBottom:24, flexWrap:'wrap' }}>
          {palabraActual.split('').map((letra, i) => (
            <div key={i} style={{ width:36, height:44, border:'2px solid', borderColor: letrasUsadas.includes(letra) ? '#7C3AED' : '#E2E6F0',
              borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center',
              fontSize:20, fontWeight:800, color:'#7C3AED', background: letrasUsadas.includes(letra) ? '#EDE9FE' : '#F9FAFB' }}>
              {letrasUsadas.includes(letra) ? letra.toUpperCase() : ''}
            </div>
          ))}
        </div>
        {(ganado || perdido) && (
          <div style={{ padding:16, borderRadius:10, marginBottom:20,
            background: ganado ? '#F0FDF4' : '#FEF2F2',
            border:'1px solid ' + (ganado ? '#22C55E' : '#EF4444') }}>
            <div style={{ fontSize:18, fontWeight:800, color: ganado ? '#166534' : '#991B1B' }}>
              {ganado ? t.excelente : t.palabraEra}{palabraActual.toUpperCase()}
            </div>
          </div>
        )}
        {!ganado && !perdido && (
          <div style={{ display:'flex', flexWrap:'wrap', gap:6, justifyContent:'center', marginBottom:16 }}>
            {teclado.map(letra => (
              <button key={letra} onClick={() => intentarLetra(letra)} disabled={letrasUsadas.includes(letra)}
                style={{ width:36, height:36, border:'1.5px solid', borderRadius:8, fontFamily:'inherit', fontSize:13, fontWeight:700, cursor: letrasUsadas.includes(letra) ? 'default' : 'pointer',
                  borderColor: letrasUsadas.includes(letra) ? (palabraActual.includes(letra) ? '#22C55E' : '#EF4444') : '#E2E6F0',
                  background: letrasUsadas.includes(letra) ? (palabraActual.includes(letra) ? '#F0FDF4' : '#FEF2F2') : '#fff',
                  color: letrasUsadas.includes(letra) ? (palabraActual.includes(letra) ? '#166534' : '#991B1B') : '#374151' }}>
                {letra.toUpperCase()}
              </button>
            ))}
          </div>
        )}
        <button onClick={reiniciar} style={{ background:'#7C3AED', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.nuevaPalabra}
        </button>
      </div>
    </div>
  )
}

function JuegoTrivia({ onVolver, usuario, onXpGanado, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const preguntas = [
    { p:'Cual es la capital de Colombia?', en:'What is the capital of Colombia?', ops:['Medellin','Cali','Bogota','Barranquilla'], c:2 },
    { p:'Como se llama la moneda de Colombia?', en:'What is the name of Colombia\'s currency?', ops:['Sol','Peso','Bolivar','Real'], c:1 },
    { p:'Cual es el plato mas tipico de Bogota?', en:'What is the most typical dish from Bogota?', ops:['Bandeja paisa','Ajiaco','Sancocho','Arepa'], c:1 },
    { p:'Como se llama el cafe mas famoso de Colombia?', en:'What is Colombia\'s most famous coffee brand called?', ops:['Cafe de Medellin','Juan Valdez','Cafe del Caribe','Cafe Andino'], c:1 },
    { p:'Cual es el rio mas largo de Colombia?', en:'What is the longest river in Colombia?', ops:['Rio Cauca','Rio Amazonas','Rio Magdalena','Rio Meta'], c:2 },
    { p:'En que ciudad nacio Gabriel Garcia Marquez?', en:'In which city was Gabriel Garcia Marquez born?', ops:['Bogota','Cartagena','Aracataca','Barranquilla'], c:2 },
    { p:'Cual es el baile tipico de la Costa Caribe?', en:'What is the typical dance from the Caribbean Coast?', ops:['Salsa','Cumbia','Tango','Vallenato'], c:1 },
    { p:'Como se llama el sombrero tipico colombiano?', en:'What is the traditional Colombian hat called?', ops:['Sombrero vueltiao','Sombrero pintao','Sombrero aguadeno','Sombrero antioqueno'], c:0 },
    { p:'Colombia es el pais con mas especies de que animal en el mundo?', en:'Colombia has the most species of which animal in the world?', ops:['Mariposas','Aves','Ranas','Peces de rio'], c:1 },
    { p:'Aproximadamente cuantas especies de aves habitan en Colombia?', en:'About how many bird species live in Colombia?', ops:['Cerca de 500','Cerca de 900','Mas de 1.900','Mas de 5.000'], c:2 },
    { p:'Donde se encuentra la palma de cera, la palma mas alta del mundo?', en:'Where is the wax palm, the tallest palm tree in the world, located?', ops:['Valle de Cocora, Quindio','Desierto de la Tatacoa','Amazonas','Sierra Nevada de Santa Marta'], c:0 },
    { p:'La palma de cera del Quindio es tambien...', en:'The wax palm of Quindio is also...', ops:['El escudo nacional','El arbol nacional de Colombia','Un simbolo de Bogota','Una especie extinta'], c:1 },
    { p:'Que altura puede alcanzar la palma de cera?', en:'How tall can the wax palm grow?', ops:['Hasta 15 metros','Hasta 30 metros','Hasta 60 metros','Hasta 100 metros'], c:2 },
    { p:'Cual es la flor nacional de Colombia?', en:'What is the national flower of Colombia?', ops:['Girasol','Orquidea Cattleya trianae','Rosa','Flor de mayo'], c:1 },
    { p:'Colombia es el pais con mayor diversidad de que planta en el mundo?', en:'Colombia has the greatest diversity of which plant in the world?', ops:['Cactus','Orquideas','Bambu','Palmeras'], c:1 },
    { p:'Colombia tiene costas sobre cuales oceanos?', en:'Which oceans does Colombia have coastlines on?', ops:['Solo el Pacifico','Solo el Atlantico','Pacifico y Caribe','Indico y Pacifico'], c:2 },
    { p:'Cuantas cordilleras andinas cruzan Colombia?', en:'How many Andean mountain ranges cross Colombia?', ops:['Una', 'Dos', 'Tres', 'Cuatro'], c:2 },
    { p:'Que hace unica a la ubicacion de Bogota entre las capitales del mundo?', en:'What makes Bogota\'s location unique among world capitals?', ops:['Es una de las capitales mas altas, a 2.640 msnm', 'Es la unica capital costera', 'Esta bajo el nivel del mar', 'Es la mas cercana al Ecuador geografico'], c:0 },
  ]
  const [idx, setIdx] = useState(0)
  const [puntaje, setPuntaje] = useState(0)
  const [seleccion, setSeleccion] = useState(null)
  const [validado, setValidado] = useState(false)
  const [terminado, setTerminado] = useState(false)
  const [traduccion, setTraduccion] = useState(idioma === 'en')

  useEffect(() => {
    if (terminado && usuario?.id && puntaje > 0) {
      axios.post(API + '/progreso/completar-juego', {
        usuario_id: usuario.id,
        xp_ganado: puntaje * 10
      }).then(() => {
        if (onXpGanado) onXpGanado()
      }).catch(console.error)
    }
  }, [terminado])

  function responder(i) {
    if (validado) return
    setSeleccion(i); setValidado(true)
    if (i === preguntas[idx].c) setPuntaje(p => p + 1)
  }

  function siguiente() {
    if (idx < preguntas.length - 1) { setIdx(i => i+1); setSeleccion(null); setValidado(false) }
    else setTerminado(true)
  }

  if (terminado) return (
    <div style={{ maxWidth:500, margin:'0 auto', textAlign:'center', padding:60 }}>
      <div style={{ fontSize:64, marginBottom:16 }}>🇨🇴</div>
      <h2 style={{ fontSize:24, fontWeight:800, marginBottom:8 }}>{t.triviaFin}</h2>
      <div style={{ fontSize:48, fontWeight:900, color:'#F59E0B', marginBottom:8 }}>{puntaje}/{preguntas.length}</div>
      {puntaje > 0 && (
        <div style={{ fontSize:16, color:'#22C55E', fontWeight:700, marginBottom:20 }}>
          ⚡ +{puntaje * 10} {t.xpGanados}
        </div>
      )}
      <div style={{ display:'flex', gap:12, justifyContent:'center' }}>
        <button onClick={() => { setIdx(0); setPuntaje(0); setSeleccion(null); setValidado(false); setTerminado(false) }}
          style={{ background:'#F59E0B', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.jugarOtra}
        </button>
        <button onClick={onVolver} style={{ background:'#E2E6F0', color:'#374151', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.volverSolo}
        </button>
      </div>
    </div>
  )

  const q = preguntas[idx]
  return (
    <div style={{ maxWidth:600, margin:'0 auto' }}>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
        <button onClick={onVolver} style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit' }}>{t.volver}</button>
        <h2 style={{ fontSize:20, fontWeight:800 }}>🇨🇴 {t.triviaTitulo}</h2>
        <span style={{ marginLeft:'auto', fontSize:13, color:'#6B7280' }}>{idx+1}/{preguntas.length}</span>
      </div>
      <div style={{ height:6, background:'#E2E6F0', borderRadius:999, marginBottom:16, overflow:'hidden' }}>
        <div style={{ width: ((idx+1)/preguntas.length*100) + '%', height:'100%', background:'#F59E0B', borderRadius:999 }} />
      </div>
      <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:8 }}>
        <BotonTraduccion activo={traduccion} onClick={() => setTraduccion(v => !v)} color="#F59E0B" t={t} />
      </div>
      <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:14, padding:32 }}>
        <p style={{ fontSize:18, fontWeight:700, marginBottom: traduccion ? 6 : 24, lineHeight:1.5 }}>{q.p}</p>
        {traduccion && (
          <p style={{ fontSize:14, color:'#6B7280', fontStyle:'italic', marginBottom:24, lineHeight:1.5 }}>{q.en}</p>
        )}
        <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:20 }}>
          {q.ops.map((op, i) => {
            let bg = '#fff', border = '#E2E6F0', color = '#374151'
            if (validado && i === q.c) { bg = '#F0FDF4'; border = '#22C55E'; color = '#166534' }
            if (validado && seleccion === i && i !== q.c) { bg = '#FEF2F2'; border = '#EF4444'; color = '#991B1B' }
            if (!validado && seleccion === i) { bg = '#FEF9C3'; border = '#F59E0B' }
            return (
              <button key={i} onClick={() => responder(i)}
                style={{ padding:'12px 16px', border:'2px solid ' + border, borderRadius:10, background:bg, color, fontFamily:'inherit', fontSize:14, cursor: validado ? 'default' : 'pointer', textAlign:'left', width:'100%' }}>
                {op}
              </button>
            )
          })}
        </div>
        {validado && (
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <span style={{ fontSize:14, fontWeight:700, color: seleccion === q.c ? '#22C55E' : '#EF4444' }}>
              {seleccion === q.c ? t.correctoPunto : t.incorrecto} — {t.puntaje} {puntaje}
            </span>
            <button onClick={siguiente} style={{ background:'#F59E0B', color:'#fff', border:'none', borderRadius:10, padding:'9px 20px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {idx < preguntas.length - 1 ? t.siguiente : t.verResultado}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

function JuegoMemoria({ onVolver, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const pares = [
    { es:'parce', en:'buddy' }, { es:'bacano', en:'awesome' },
    { es:'chevere', en:'cool' }, { es:'tinto', en:'coffee' },
    { es:'parchar', en:'hang out' }, { es:'ajiaco', en:'stew' },
  ]
  const [cartas] = useState(() => {
    const todas = [...pares.map((p,i) => ({ id:i*2, texto:p.es, grupo:i, tipo:'es' })),
                   ...pares.map((p,i) => ({ id:i*2+1, texto:p.en, grupo:i, tipo:'en' }))]
    return todas.sort(() => Math.random() - 0.5)
  })
  const [volteadas, setVolteadas] = useState([])
  const [encontradas, setEncontradas] = useState([])
  const [intentos, setIntentos] = useState(0)

  function voltear(id) {
    if (volteadas.length === 2) return
    const carta = cartas.find(c => c.id === id)
    if (encontradas.includes(carta.grupo) || volteadas.includes(id)) return
    const nuevas = [...volteadas, id]
    setVolteadas(nuevas)
    if (nuevas.length === 2) {
      setIntentos(i => i+1)
      const [a, b] = nuevas.map(i => cartas.find(c => c.id === i))
      if (a.grupo === b.grupo) { setEncontradas(prev => [...prev, a.grupo]); setVolteadas([]) }
      else setTimeout(() => setVolteadas([]), 1000)
    }
  }

  const terminado = encontradas.length === pares.length
  return (
    <div style={{ maxWidth:600, margin:'0 auto' }}>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
        <button onClick={onVolver} style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit' }}>{t.volver}</button>
        <h2 style={{ fontSize:20, fontWeight:800 }}>🧠 {t.memoriaTitulo}</h2>
        <span style={{ marginLeft:'auto', fontSize:13, color:'#6B7280' }}>{t.intentos} {intentos}</span>
      </div>
      {terminado ? (
        <div style={{ textAlign:'center', padding:40 }}>
          <div style={{ fontSize:64, marginBottom:12 }}>🎉</div>
          <h3 style={{ fontSize:22, fontWeight:800, color:'#059669' }}>{t.completadoEn} {intentos} {t.intentosPl}</h3>
          <button onClick={onVolver} style={{ marginTop:20, background:'#059669', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
            {t.volverSolo}
          </button>
        </div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:10 }}>
          {cartas.map(carta => {
            const visible = volteadas.includes(carta.id) || encontradas.includes(carta.grupo)
            const encontrada = encontradas.includes(carta.grupo)
            return (
              <div key={carta.id} onClick={() => voltear(carta.id)}
                style={{ height:70, borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', fontSize:13, fontWeight:700, textAlign:'center', padding:6,
                  background: encontrada ? '#F0FDF4' : visible ? (carta.tipo==='es' ? '#EDE9FE' : '#EFF6FF') : '#1B3A8C',
                  color: encontrada ? '#166534' : visible ? '#1A1A2E' : '#fff',
                  border:'2px solid ' + (encontrada ? '#22C55E' : visible ? '#7C3AED' : '#1B3A8C') }}>
                {visible ? carta.texto : '?'}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

function JuegoOrdenar({ onVolver, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const frases = [
    { palabras:['Hola','me','llamo','Carlos'], correcta:'Hola me llamo Carlos', traduccion:'Hello my name is Carlos' },
    { palabras:['Quiero','aprender','español'], correcta:'Quiero aprender español', traduccion:'I want to learn Spanish' },
    { palabras:['El','ajiaco','es','delicioso'], correcta:'El ajiaco es delicioso', traduccion:'The ajiaco is delicious' },
    { palabras:['Buenos','dias','parcero'], correcta:'Buenos dias parcero', traduccion:'Good morning buddy' },
    { palabras:['Me','gusta','el','tinto'], correcta:'Me gusta el tinto', traduccion:'I like the black coffee' },
  ]
  const [idx, setIdx] = useState(0)
  const [disponibles, setDisponibles] = useState(() => [...frases[0].palabras].sort(() => Math.random() - 0.5))
  const [seleccionadas, setSeleccionadas] = useState([])
  const [validado, setValidado] = useState(false)
  const [puntaje, setPuntaje] = useState(0)
  const [terminado, setTerminado] = useState(false)

  const frase = frases[idx]
  const correcto = seleccionadas.join(' ') === frase.correcta

  function seleccionar(palabra, i) {
    if (validado) return
    setDisponibles(prev => prev.filter((_, j) => j !== i))
    setSeleccionadas(prev => [...prev, palabra])
  }

  function quitar(palabra, i) {
    if (validado) return
    setSeleccionadas(prev => prev.filter((_, j) => j !== i))
    setDisponibles(prev => [...prev, palabra])
  }

  function validar() {
    setValidado(true)
    if (correcto) setPuntaje(p => p+1)
  }

  function siguiente() {
    if (idx < frases.length - 1) {
      const sig = idx + 1
      setIdx(sig); setDisponibles([...frases[sig].palabras].sort(() => Math.random() - 0.5))
      setSeleccionadas([]); setValidado(false)
    } else setTerminado(true)
  }

  if (terminado) return (
    <div style={{ maxWidth:500, margin:'0 auto', textAlign:'center', padding:60 }}>
      <div style={{ fontSize:64, marginBottom:16 }}>📝</div>
      <h2 style={{ fontSize:24, fontWeight:800, marginBottom:8 }}>{t.juegoFin}</h2>
      <div style={{ fontSize:48, fontWeight:900, color:'#F07C1E', marginBottom:16 }}>{puntaje}/{frases.length}</div>
      <div style={{ display:'flex', gap:12, justifyContent:'center' }}>
        <button onClick={() => { setIdx(0); setPuntaje(0); setDisponibles([...frases[0].palabras].sort(() => Math.random() - 0.5)); setSeleccionadas([]); setValidado(false); setTerminado(false) }}
          style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.jugarOtra}
        </button>
        <button onClick={onVolver} style={{ background:'#E2E6F0', color:'#374151', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.volverSolo}
        </button>
      </div>
    </div>
  )

  return (
    <div style={{ maxWidth:600, margin:'0 auto' }}>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
        <button onClick={onVolver} style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit' }}>{t.volver}</button>
        <h2 style={{ fontSize:20, fontWeight:800 }}>📝 {t.ordenarTitulo}</h2>
        <span style={{ marginLeft:'auto', fontSize:13, color:'#6B7280' }}>{idx+1}/{frases.length}</span>
      </div>
      <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:14, padding:32 }}>
        <p style={{ fontSize:13, color:'#6B7280', marginBottom:6 }}>{t.traduccionLbl} <em>{frase.traduccion}</em></p>
        <p style={{ fontSize:14, fontWeight:600, marginBottom:20 }}>{t.ordenaPalabras}</p>
        <div style={{ minHeight:52, background:'#F4F6FA', borderRadius:10, padding:'10px 12px', marginBottom:16, display:'flex', flexWrap:'wrap', gap:8, alignItems:'center' }}>
          {seleccionadas.length === 0
            ? <span style={{ fontSize:13, color:'#9CA3AF' }}>{t.tocaPalabras}</span>
            : seleccionadas.map((p, i) => (
                <button key={i} onClick={() => quitar(p, i)} disabled={validado}
                  style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:8, padding:'6px 12px', fontSize:13, fontWeight:600, cursor: validado ? 'default' : 'pointer' }}>
                  {p}
                </button>
              ))
          }
        </div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginBottom:20 }}>
          {disponibles.map((p, i) => (
            <button key={i} onClick={() => seleccionar(p, i)} disabled={validado}
              style={{ background:'#fff', border:'1.5px solid #E2E6F0', borderRadius:8, padding:'6px 12px', fontSize:13, fontWeight:600, cursor: validado ? 'default' : 'pointer', color:'#374151' }}>
              {p}
            </button>
          ))}
        </div>
        {validado && (
          <div style={{ padding:'12px 16px', borderRadius:10, marginBottom:16, fontSize:13,
            background: correcto ? '#F0FDF4' : '#FEF2F2',
            border:'1px solid ' + (correcto ? '#22C55E' : '#EF4444'),
            color: correcto ? '#166534' : '#991B1B' }}>
            {correcto ? t.correcto : t.fraseCorrecta + ' ' + frase.correcta}
          </div>
        )}
        <div style={{ display:'flex', justifyContent:'flex-end' }}>
          {!validado
            ? <button disabled={seleccionadas.length === 0} onClick={validar}
                style={{ background: seleccionadas.length > 0 ? '#F07C1E' : '#E2E6F0', color: seleccionadas.length > 0 ? '#fff' : '#9CA3AF', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: seleccionadas.length > 0 ? 'pointer' : 'not-allowed' }}>
                {t.comprobar}
              </button>
            : <button onClick={siguiente}
                style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
                {idx < frases.length - 1 ? t.siguiente : t.verResultado}
              </button>
          }
        </div>
      </div>
    </div>
  )
}

/* ── NUEVO JUEGO: VERDADERO O FALSO (reemplaza Sopa de Letras) ── */
function JuegoVerdaderoFalso({ onVolver, usuario, onXpGanado, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const afirmaciones = [
    { texto:'Colombia es el pais con mas especies de aves del mundo.', en:'Colombia is the country with the most bird species in the world.', v:true,  dato:'Tiene mas de 1.900 especies registradas.', datoEn:'It has more than 1,900 registered species.' },
    { texto:'La palma de cera del Quindio es el arbol mas alto del mundo.', en:'The wax palm of Quindio is the tallest tree in the world.', v:false, dato:'Es la palma mas alta del mundo, pero no el arbol mas alto en general.', datoEn:'It is the tallest palm tree in the world, but not the tallest tree overall.' },
    { texto:'Bogota es una de las capitales mas altas de America.', en:'Bogota is one of the highest capital cities in America.', v:true,  dato:'Esta a 2.640 metros sobre el nivel del mar.', datoEn:'It sits at 2,640 meters above sea level.' },
    { texto:'Colombia solo tiene costa sobre el Oceano Pacifico.', en:'Colombia only has coastline on the Pacific Ocean.', v:false, dato:'Tiene costa sobre el Pacifico y el mar Caribe.', datoEn:'It has coastline on both the Pacific and the Caribbean Sea.' },
    { texto:'La flor nacional de Colombia es la orquidea.', en:'The national flower of Colombia is the orchid.', v:true,  dato:'Es la Cattleya trianae.', datoEn:'It is the Cattleya trianae.' },
    { texto:'Colombia tiene selva amazonica en su territorio.', en:'Colombia has Amazon rainforest within its territory.', v:true,  dato:'Gran parte del sur del pais es selva amazonica.', datoEn:'A large part of the south of the country is Amazon rainforest.' },
    { texto:'El ajiaco es un plato tipico de la costa Caribe.', en:'Ajiaco is a typical dish from the Caribbean coast.', v:false, dato:'Es un plato tipico de Bogota y la region andina.', datoEn:'It is a typical dish from Bogota and the Andean region.' },
    { texto:'Colombia es uno de los paises con mas especies de orquideas del mundo.', en:'Colombia is one of the countries with the most orchid species in the world.', v:true,  dato:'Se calculan mas de 4.000 especies distintas.', datoEn:'More than 4,000 different species are estimated.' },
    { texto:'El vallenato es un genero musical originario del Pacifico colombiano.', en:'Vallenato is a music genre originally from the Colombian Pacific.', v:false, dato:'Es originario de la region Caribe, en el Magdalena Grande.', datoEn:'It originates from the Caribbean region, in Magdalena Grande.' },
    { texto:'La palma de cera puede superar los 40 metros de altura.', en:'The wax palm can grow taller than 40 meters.', v:true,  dato:'Puede alcanzar hasta 60 metros en algunos casos.', datoEn:'It can reach up to 60 meters in some cases.' },
    { texto:'Colombia solo tiene una cordillera andina en su territorio.', en:'Colombia only has one Andean mountain range in its territory.', v:false, dato:'Tiene tres: Occidental, Central y Oriental.', datoEn:'It has three: Western, Central, and Eastern.' },
    { texto:'Gabriel Garcia Marquez nacio en Aracataca.', en:'Gabriel Garcia Marquez was born in Aracataca.', v:true,  dato:'Este pueblo inspiro a Macondo en Cien años de soledad.', datoEn:'This town inspired Macondo in One Hundred Years of Solitude.' },
  ]
  const [orden] = useState(() => [...afirmaciones].sort(() => Math.random() - 0.5))
  const [idx, setIdx] = useState(0)
  const [puntaje, setPuntaje] = useState(0)
  const [tiempo, setTiempo] = useState(8)
  const [respondido, setRespondido] = useState(null)
  const [terminado, setTerminado] = useState(false)
  const [traduccion, setTraduccion] = useState(idioma === 'en')

  const TIEMPO_INICIAL = 8

  useEffect(() => {
    if (terminado || respondido !== null) return
    if (tiempo <= 0) { manejarRespuesta(null); return }
    const timer = setTimeout(() => setTiempo(s => s - 1), 1000)
    return () => clearTimeout(timer)
  }, [tiempo, respondido, terminado])

  useEffect(() => {
    if (terminado && usuario?.id && puntaje > 0) {
      axios.post(API + '/progreso/completar-juego', {
        usuario_id: usuario.id,
        xp_ganado: puntaje * 8
      }).then(() => { if (onXpGanado) onXpGanado() }).catch(console.error)
    }
  }, [terminado])

  function manejarRespuesta(respuesta) {
    if (respondido !== null) return
    setRespondido(respuesta)
    if (respuesta === orden[idx].v) setPuntaje(p => p + 1)
  }

  function siguiente() {
    if (idx < orden.length - 1) {
      setIdx(i => i + 1); setRespondido(null); setTiempo(TIEMPO_INICIAL)
    } else setTerminado(true)
  }

  if (terminado) return (
    <div style={{ maxWidth:500, margin:'0 auto', textAlign:'center', padding:60 }}>
      <div style={{ fontSize:64, marginBottom:16 }}>⚖️</div>
      <h2 style={{ fontSize:24, fontWeight:800, marginBottom:8 }}>{t.vofFin}</h2>
      <div style={{ fontSize:48, fontWeight:900, color:'#3B82F6', marginBottom:8 }}>{puntaje}/{orden.length}</div>
      {puntaje > 0 && (
        <div style={{ fontSize:16, color:'#22C55E', fontWeight:700, marginBottom:20 }}>
          ⚡ +{puntaje * 8} {t.xpGanados}
        </div>
      )}
      <div style={{ display:'flex', gap:12, justifyContent:'center' }}>
        <button onClick={() => { setIdx(0); setPuntaje(0); setTiempo(TIEMPO_INICIAL); setRespondido(null); setTerminado(false) }}
          style={{ background:'#3B82F6', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.jugarOtra}
        </button>
        <button onClick={onVolver} style={{ background:'#E2E6F0', color:'#374151', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.volverSolo}
        </button>
      </div>
    </div>
  )

  const a = orden[idx]
  const correcto = respondido === a.v

  return (
    <div style={{ maxWidth:600, margin:'0 auto' }}>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
        <button onClick={onVolver} style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit' }}>{t.volver}</button>
        <h2 style={{ fontSize:20, fontWeight:800 }}>⚖️ {t.vofTitulo}</h2>
        <span style={{ marginLeft:'auto', fontSize:13, color:'#6B7280' }}>{idx+1}/{orden.length}</span>
      </div>
      <div style={{ height:6, background:'#E2E6F0', borderRadius:999, marginBottom:16, overflow:'hidden' }}>
        <div style={{ width: ((idx+1)/orden.length*100) + '%', height:'100%', background:'#3B82F6', borderRadius:999 }} />
      </div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
        <BotonTraduccion activo={traduccion} onClick={() => setTraduccion(v => !v)} color="#3B82F6" t={t} />
        <div style={{ fontSize:13, fontWeight:800, padding:'4px 12px', borderRadius:999,
          background: tiempo <= 3 ? '#FEF2F2' : '#EFF6FF', color: tiempo <= 3 ? '#991B1B' : '#1D4ED8' }}>
          ⏱ {tiempo}s
        </div>
      </div>
      <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:14, padding:32 }}>
        <p style={{ fontSize:18, fontWeight:700, marginBottom: traduccion ? 6 : 24, lineHeight:1.5 }}>{a.texto}</p>
        {traduccion && (
          <p style={{ fontSize:14, color:'#6B7280', fontStyle:'italic', marginBottom:24, lineHeight:1.5 }}>{a.en}</p>
        )}
        <div style={{ display:'flex', gap:12, marginBottom:20 }}>
          <button onClick={() => manejarRespuesta(true)} disabled={respondido !== null}
            style={{ flex:1, padding:'16px', borderRadius:12, border:'2px solid', fontFamily:'inherit', fontSize:15, fontWeight:800, cursor: respondido !== null ? 'default' : 'pointer',
              borderColor: respondido !== null && a.v === true ? '#22C55E' : (respondido !== null && respondido === true ? '#EF4444' : '#E2E6F0'),
              background: respondido !== null && a.v === true ? '#F0FDF4' : (respondido !== null && respondido === true ? '#FEF2F2' : '#fff'),
              color: respondido !== null && a.v === true ? '#166534' : (respondido !== null && respondido === true ? '#991B1B' : '#374151') }}>
            ✅ {t.verdadero}
          </button>
          <button onClick={() => manejarRespuesta(false)} disabled={respondido !== null}
            style={{ flex:1, padding:'16px', borderRadius:12, border:'2px solid', fontFamily:'inherit', fontSize:15, fontWeight:800, cursor: respondido !== null ? 'default' : 'pointer',
              borderColor: respondido !== null && a.v === false ? '#22C55E' : (respondido !== null && respondido === false ? '#EF4444' : '#E2E6F0'),
              background: respondido !== null && a.v === false ? '#F0FDF4' : (respondido !== null && respondido === false ? '#FEF2F2' : '#fff'),
              color: respondido !== null && a.v === false ? '#166534' : (respondido !== null && respondido === false ? '#991B1B' : '#374151') }}>
            ❌ {t.falso}
          </button>
        </div>
        {respondido !== null && (
          <>
            <div style={{ padding:'12px 16px', borderRadius:10, marginBottom:16, fontSize:13,
              background: correcto ? '#F0FDF4' : '#FEF2F2', border:'1px solid ' + (correcto ? '#22C55E' : '#EF4444'),
              color: correcto ? '#166534' : '#991B1B' }}>
              {correcto ? t.correcto + ' ' : t.incorrecto + '. '}{idioma === 'en' ? a.datoEn : a.dato}
              {traduccion && idioma !== 'en' && <div style={{ marginTop:4, fontStyle:'italic', opacity:.85 }}>{a.datoEn}</div>}
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end' }}>
              <button onClick={siguiente} style={{ background:'#3B82F6', color:'#fff', border:'none', borderRadius:10, padding:'9px 20px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
                {idx < orden.length - 1 ? t.siguiente : t.verResultado}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

/* ── NUEVO JUEGO: CONJUGACION RAPIDA (habilitado) ── */
function JuegoVerbos({ onVolver, usuario, onXpGanado, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const preguntas = [
    { verbo:'hablar', persona:'yo',        tiempo:'presente',   tiempoEn:'present',   ops:['hablo','hablas','habla','hablan'], c:0 },
    { verbo:'comer',  persona:'tu',        tiempo:'presente',   tiempoEn:'present',   ops:['como','comes','come','comen'], c:1 },
    { verbo:'vivir',  persona:'ella',      tiempo:'presente',   tiempoEn:'present',   ops:['vivo','vives','vive','viven'], c:2 },
    { verbo:'hablar', persona:'nosotros',  tiempo:'presente',   tiempoEn:'present',   ops:['hablamos','hablais','hablan','hablo'], c:0 },
    { verbo:'ser',    persona:'yo',        tiempo:'presente',   tiempoEn:'present',   ops:['soy','eres','es','somos'], c:0 },
    { verbo:'estar',  persona:'tu',        tiempo:'presente',   tiempoEn:'present',   ops:['estoy','estas','esta','estan'], c:1 },
    { verbo:'tener',  persona:'el',        tiempo:'presente',   tiempoEn:'present',   ops:['tengo','tienes','tiene','tenemos'], c:2 },
    { verbo:'ir',     persona:'nosotros',  tiempo:'presente',   tiempoEn:'present',   ops:['voy','vas','va','vamos'], c:3 },
    { verbo:'hablar', persona:'yo',        tiempo:'preterito',  tiempoEn:'preterite', ops:['hable','hablaste','hablo','hablaron'], c:0 },
    { verbo:'comer',  persona:'ella',      tiempo:'preterito',  tiempoEn:'preterite', ops:['comi','comiste','comio','comieron'], c:2 },
    { verbo:'vivir',  persona:'ellos',     tiempo:'preterito',  tiempoEn:'preterite', ops:['vivi','viviste','vivio','vivieron'], c:3 },
    { verbo:'ser',    persona:'tu',        tiempo:'preterito',  tiempoEn:'preterite', ops:['fui','fuiste','fue','fueron'], c:1 },
    { verbo:'hablar', persona:'yo',        tiempo:'futuro',     tiempoEn:'future',    ops:['hablare','hablaras','hablara','hablaran'], c:0 },
    { verbo:'comer',  persona:'nosotros',  tiempo:'futuro',     tiempoEn:'future',    ops:['comere','comeras','comeremos','comeran'], c:2 },
    { verbo:'vivir',  persona:'ustedes',   tiempo:'futuro',     tiempoEn:'future',    ops:['vivire','viviras','vivira','viviran'], c:3 },
  ]
  const personasEn = { yo:'I', tu:'you', el:'he', ella:'she', nosotros:'we', ellos:'they', ustedes:'you all' }
  const [orden] = useState(() => [...preguntas].sort(() => Math.random() - 0.5))
  const [idx, setIdx] = useState(0)
  const [puntaje, setPuntaje] = useState(0)
  const [tiempo, setTiempo] = useState(10)
  const [seleccion, setSeleccion] = useState(null)
  const [validado, setValidado] = useState(false)
  const [terminado, setTerminado] = useState(false)
  const [traduccion, setTraduccion] = useState(idioma === 'en')

  const TIEMPO_INICIAL = 10

  useEffect(() => {
    if (terminado || validado) return
    if (tiempo <= 0) { responder(-1); return }
    const timer = setTimeout(() => setTiempo(s => s - 1), 1000)
    return () => clearTimeout(timer)
  }, [tiempo, validado, terminado])

  useEffect(() => {
    if (terminado && usuario?.id && puntaje > 0) {
      axios.post(API + '/progreso/completar-juego', {
        usuario_id: usuario.id,
        xp_ganado: puntaje * 12
      }).then(() => { if (onXpGanado) onXpGanado() }).catch(console.error)
    }
  }, [terminado])

  function responder(i) {
    if (validado) return
    setSeleccion(i); setValidado(true)
    if (i === orden[idx].c) setPuntaje(p => p + 1)
  }

  function siguiente() {
    if (idx < orden.length - 1) {
      setIdx(i => i + 1); setSeleccion(null); setValidado(false); setTiempo(TIEMPO_INICIAL)
    } else setTerminado(true)
  }

  if (terminado) return (
    <div style={{ maxWidth:500, margin:'0 auto', textAlign:'center', padding:60 }}>
      <div style={{ fontSize:64, marginBottom:16 }}>⚡</div>
      <h2 style={{ fontSize:24, fontWeight:800, marginBottom:8 }}>{t.verbosFin}</h2>
      <div style={{ fontSize:48, fontWeight:900, color:'#EF4444', marginBottom:8 }}>{puntaje}/{orden.length}</div>
      {puntaje > 0 && (
        <div style={{ fontSize:16, color:'#22C55E', fontWeight:700, marginBottom:20 }}>
          ⚡ +{puntaje * 12} {t.xpGanados}
        </div>
      )}
      <div style={{ display:'flex', gap:12, justifyContent:'center' }}>
        <button onClick={() => { setIdx(0); setPuntaje(0); setTiempo(TIEMPO_INICIAL); setSeleccion(null); setValidado(false); setTerminado(false) }}
          style={{ background:'#EF4444', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.jugarOtra}
        </button>
        <button onClick={onVolver} style={{ background:'#E2E6F0', color:'#374151', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.volverSolo}
        </button>
      </div>
    </div>
  )

  const q = orden[idx]
  return (
    <div style={{ maxWidth:600, margin:'0 auto' }}>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
        <button onClick={onVolver} style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit' }}>{t.volver}</button>
        <h2 style={{ fontSize:20, fontWeight:800 }}>⚡ {t.verbosTitulo}</h2>
        <span style={{ marginLeft:'auto', fontSize:13, color:'#6B7280' }}>{idx+1}/{orden.length}</span>
      </div>
      <div style={{ height:6, background:'#E2E6F0', borderRadius:999, marginBottom:16, overflow:'hidden' }}>
        <div style={{ width: ((idx+1)/orden.length*100) + '%', height:'100%', background:'#EF4444', borderRadius:999 }} />
      </div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
        <BotonTraduccion activo={traduccion} onClick={() => setTraduccion(v => !v)} color="#EF4444" t={t} />
        <div style={{ fontSize:13, fontWeight:800, padding:'4px 12px', borderRadius:999,
          background: tiempo <= 3 ? '#FEF2F2' : '#FEF9C3', color: tiempo <= 3 ? '#991B1B' : '#854D0E' }}>
          ⏱ {tiempo}s
        </div>
      </div>
      <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:14, padding:32 }}>
        <div style={{ fontSize:12, color:'#6B7280', marginBottom:6, textTransform:'uppercase', letterSpacing:1 }}>
          {q.tiempo}{traduccion ? ' (' + q.tiempoEn + ')' : ''}
        </div>
        <p style={{ fontSize:18, fontWeight:700, marginBottom: traduccion ? 6 : 24, lineHeight:1.5 }}>
          {t.conjuga} <strong>{q.verbo}</strong> {t.para} <strong>{q.persona}</strong>
        </p>
        {traduccion && (
          <p style={{ fontSize:14, color:'#6B7280', fontStyle:'italic', marginBottom:24, lineHeight:1.5 }}>
            Conjugate "{q.verbo}" for "{personasEn[q.persona] || q.persona}"
          </p>
        )}
        <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:20 }}>
          {q.ops.map((op, i) => {
            let bg = '#fff', border = '#E2E6F0', color = '#374151'
            if (validado && i === q.c) { bg = '#F0FDF4'; border = '#22C55E'; color = '#166534' }
            if (validado && seleccion === i && i !== q.c) { bg = '#FEF2F2'; border = '#EF4444'; color = '#991B1B' }
            return (
              <button key={i} onClick={() => responder(i)}
                style={{ padding:'12px 16px', border:'2px solid ' + border, borderRadius:10, background:bg, color, fontFamily:'inherit', fontSize:14, cursor: validado ? 'default' : 'pointer', textAlign:'left', width:'100%' }}>
                {op}
              </button>
            )
          })}
        </div>
        {validado && (
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <span style={{ fontSize:14, fontWeight:700, color: seleccion === q.c ? '#22C55E' : '#EF4444' }}>
              {seleccion === q.c ? t.correctoPunto : (seleccion === -1 ? t.tiempoAgotado : t.incorrecto)} — {t.puntaje} {puntaje}
            </span>
            <button onClick={siguiente} style={{ background:'#EF4444', color:'#fff', border:'none', borderRadius:10, padding:'9px 20px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {idx < orden.length - 1 ? t.siguiente : t.verResultado}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
